/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var DlpOverrideOptions;
(function (DlpOverrideOptions) {
    /**No override is allowed. */
    DlpOverrideOptions[DlpOverrideOptions["None"] = 0] = "None";
    /**Override is allowed without requiring justification. */
    DlpOverrideOptions[DlpOverrideOptions["Allow"] = 1] = "Allow";
    /**Override is allowed as long as justification is provided. */
    DlpOverrideOptions[DlpOverrideOptions["AllowWithJustification"] = 2] = "AllowWithJustification";
})(DlpOverrideOptions || (DlpOverrideOptions = {}));
/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var DlpOverrideUserAction;
(function (DlpOverrideUserAction) {
    /**  Override the applied action. */
    DlpOverrideUserAction[DlpOverrideUserAction["Override"] = 0] = "Override";
    /**Report false positive. */
    DlpOverrideUserAction[DlpOverrideUserAction["ReportFalsePositive"] = 1] = "ReportFalsePositive";
})(DlpOverrideUserAction || (DlpOverrideUserAction = {}));
//# sourceMappingURL=InformationProtectionService.js.map